"use client";

import { c as _c } from "react/compiler-runtime";
import { useParams } from "next/navigation";
import { PageBreadcrumbs } from "@/components/page-breadcrumbs";
import { PageWrapper } from "@/components/page-wrapper";
import { CusteioDocumentDraft } from "@/components/projects/new/custeio-document-draft";
import { ProjectBasicForm } from "@/components/projects/new/project-basic-form";
export default function NewProjectPage() {
  const $ = _c(10);
  const params = useParams();
  const organizationSlug = params.organizationSlug as string;
  const t0 = `/${organizationSlug}/projects`;
  let t1;
  if ($[0] !== t0) {
    t1 = <PageBreadcrumbs items={[{
      label: "Projetos",
      href: t0
    }]} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== organizationSlug) {
    t2 = <CusteioDocumentDraft organizationSlug={organizationSlug} />;
    $[2] = organizationSlug;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProjectBasicForm />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="container mx-auto flex flex-col gap-8">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <PageWrapper breadcrumb={t1} maxWidth="wizard" title="Novo projeto">{t4}</PageWrapper>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}